export const Header = (props) => {
  return (
    <header id='header'>
      <div className='intro piano-background'>
        <div className='overlay'>
          <div className='container'>
          
            <div className='row'>
              <div className='col-md-8 col-md-offset-2 intro-text'>
                <h1>Life is like a piano&hellip;</h1>
                <p>&hellip;what you get out of it depends on how you play it.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
